<template>
  <div class="title">
    <div class="chinese">关于我们</div>
    <div class="hx"></div>
    <div class="eng">About us</div>
  </div>
</template>

<script>
export default {
  name: "SmallTitle"
}
</script>

<style scoped lang="scss">
.title {
  width: 615px;
  height: auto;
  .chinese {
    width: 120px;
    height: 42px;
    font-weight: 700;
    font-size: 30px;
    line-height: 42px;
    color: #333333;
    margin-left: 7.5px;
  }

  .hx {
    width: 135px;
    height: 7px;
    margin-top: -11px;
    background: rgba(29, 181, 161, 0.14);
  }

  .eng {
    //width: 473px;
    height: 28px;
    font-weight: 400;
    font-size: 16px;
    line-height: 177%;
    color: #CCCCCC;
    margin-left: 142px;
    margin-top: -24px;
  }
}
</style>
